import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { logWarn } from "../lib/logger";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const defaults = {
  show_rejected_in_main: false,
  auto_archive_on_rejection: true,
  reminders_inapp: true,
  nudge_days: 14,
  default_visibility: "link",
};

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [settings, setSettings] = useState(defaults);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const r = await api.get("/settings");
      setSettings({ ...defaults, ...r.data });
    } catch (error) {
      logWarn("Settings load failed:", error);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ settings, refresh }), [settings, refresh]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext) || { settings: defaults, refresh: () => {} };
